<template>
  <div>
    <el-dialog title="收货地址" :visible.sync="dialogFormVisible" @close="handleCloseDialog">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.receive" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" :label-width="formLabelWidth">
          <el-cascader v-model="form.value" separator=" " :options="options" :props="cascaderProps" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.address">
          </el-input>
        </el-form-item>
        <el-form-item label="设为默认" :label-width="formLabelWidth">
          <el-switch v-model="form.isDefault" active-text="">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddressToServer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import city from '../utils/city'
import utils from '../utils/index'
import {
  Usercenter
} from "../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'dialogaddress',
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          value: [''],
          phone: "",
          receive: "",
          address: "",
          isDefault: false,
          selectArr: [],
          radioIndex: ""
        }
      }
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formLabelWidth: '80px',
      dialogFormVisible: false,
      cascaderProps: {
        label: "name",//指定选项标签为选项对象的某个属性值
        value: "name"//指定选项的值为选项对象的某个属性值
      },
      options: city
    }
  },
  components: {

  },
  methods: {
    handleCloseDialog() {
      this.dialogFormVisible = false;
      this.$emit('close', true)
    },
    handleFormVisible() {
      this.$emit('open', true)
      this.dialogFormVisible = true;
    },
    handleChange(data) {
      this.form.selectArr = data;
      console.log(1, this.form.value)
    },
    handleUpdateAddress(item) {
      let _this = this;
      let arr = [];
      arr[0] = item.province;
      arr[1] = item.city;
      arr[2] = item.area;
      _this.form.address = item.address;
      _this.form.receive = item.receive;
      _this.form.phone = item.phone;
      _this.form.selectArr = arr;
      _this.form.value = arr;
      _this.form.isDefault = item.is_default ? true : false;
    },
    submitAddressToServer() {
      let _this = this;
      let is_default = this.form.isDefault ? 1 : 0;
      let selectArr = this.form.selectArr;
      if (selectArr.length <= 0) {
        _this.$message({
          message: '请选择您所在的地区',
          type: 'error'
        });
        return
      }
      let addressJson = { //数据
        is_default: is_default,
        customer_id: _this.user ? _this.user.id : "",
        province: _this.form.selectArr[0],
        city: _this.form.selectArr[1],
        area: _this.form.selectArr[2],
        address: _this.form.address,
        receive: _this.form.receive,
        phone: _this.form.phone
      }
      if (_this.form.id) {
        addressJson.id = _this.form.id;
      }
      utils.checkAddressIsright(_this.form.receive, _this.form.address, _this.form.phone).then(() => {
        if (_this.form.id) {
          usercenter.updateAddress(addressJson).then((res) => {
            //location.reload();
            _this.handleCloseDialog()
            _this.$emit('dialogTarget', { msg: true, data: res })
          })
        } else {
          usercenter.createAddress(addressJson).then((res) => {
            //location.reload();
            _this.handleCloseDialog()
            _this.$emit('dialogTarget', { msg: true, data: res })
          })
        }

      }, (res) => {
        _this.$emit('dialogTarget', { msg: false, data: res })
        _this.$message({
          message: res,
          type: 'error'
        });
      })

    },
  },
  watch: {
    'dialog': function (newVal) {
      this.dialogFormVisible = newVal
    }
  }
}
</script>